import RlAuxiliaryAnalysisInfoTooltip from "../../../../components/RlAuxiliaryAnalysisInfoTooltip";

export const ANALYSIS_METHOD = Object.freeze({
  CLOUD: {
    ICON: "cloud-intelligence",
    TITLE_ICON: null,
    TITLE: "File Threat Intelligence",
    SHORT_NAME: "cloud-intelligence"
  },
  NETWORK_THREAT: {
    ICON: "network-threat-intelligence",
    TITLE_ICON: null,
    TITLE: "Network Threat Intelligence",
    SHORT_NAME: null
  },
  RL_SANDBOX: {
    ICON: "dynamic-analysis",
    TITLE_ICON: "rl-logo-square",
    TITLE: "Cloud Sandbox",
    SHORT_NAME: "dynamic-analysis-rl"
  },
  RL_AUXILIARY_ANALYSIS: {
    ICON: "auxiliary-analysis",
    TITLE_ICON: "rl-logo-square",
    TITLE: (
      <>
        Auxiliary Analysis <RlAuxiliaryAnalysisInfoTooltip />
      </>
    ),
    SHORT_NAME: "rl_auxiliary_analysis"
  },
  STATIC: {
    ICON: "static-analysis",
    TITLE_ICON: null,
    TITLE: "Static Analysis",
    SHORT_NAME: "static-analysis"
  }
});

export const INTEGRATION_ANALYSIS_METHOD = Object.freeze({
  CAPE: {
    ICON: "cape",
    TITLE: "CAPE",
    SHORT_NAME: "cape"
  },
  CISCO_SECURE_MALWARE_ANALYTICS: {
    ICON: "cisco_secure_malware_analytics",
    TITLE: "Cisco Secure Malware Analytics",
    SHORT_NAME: "cisco_secure_malware_analytics"
  },
  CUCKOO: {
    ICON: "cuckoo",
    TITLE: "Cuckoo",
    SHORT_NAME: "cuckoo"
  },
  FIRE_EYE: {
    ICON: "fireeye",
    TITLE: "FireEye",
    SHORT_NAME: "fireeye"
  },
  JOE: {
    ICON: "joe",
    TITLE: "Joe Sandbox",
    SHORT_NAME: "joe"
  },
  VMRAY_TCBASE: {
    ICON: "vmray_tcbase",
    TITLE: "VMRay",
    SHORT_NAME: "vmray_tcbase"
  }
});

export const ANALYSIS_CLASSIFICATION = Object.freeze({
  SUSPICIOUS: "suspicious",
  UNKNOWN: "unknown",
  MALICIOUS: "malicious",
  GOODWARE: "goodware",
  NO_THREATS_FOUND: "no threats found"
});

const INITIAL_STATE = {
  isConfigured: null,
  fileTypeSupported: null,
  fileOversized: null,
  neverSubmitted: null,
  isProcessing: null,
  last_completed_on: null,
  errorMessage: null
};

export const INITIAL_QUERY_DATA = {
  cape: INITIAL_STATE,
  cisco_secure_malware_analytics: INITIAL_STATE,
  cuckoo: INITIAL_STATE,
  fireeye: INITIAL_STATE,
  joe: INITIAL_STATE,
  vmray_tcbase: INITIAL_STATE,
  core: {
    isProcessing: null,
    analysisVersion: null
  },
  cloud: {
    isProcessing: null,
    isConfigured: true,
    lastAnalysis: null
  },
  rlSandbox: {
    ...INITIAL_STATE,
    analysisStatus: null,
    availableInRca2: null
  },
  rl_auxiliary_analysis: {
    ...INITIAL_STATE,
    analysisStatus: null,
    availableInRca2: null
  }
};
